// extracted by mini-css-extract-plugin
export default {"baseFontSize":"16px"};